import React from "react";
import FormInput from "../widgets/FormInput";
import { cn, getCustomizationValue, showSuccessToast } from "src/lib/utils";
import * as Yup from "yup";
import { Formik } from "formik";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCustomer } from "src/api/customer";
import { usePortalContext } from "src/context/PortalContext";
import { Button } from "../ui/button";
import { useAuth } from "src/providers/AuthProvider";

const validationSchema = Yup.object().shape({
	first_name: Yup.string().required("This field is required"),
	last_name: Yup.string().required("This field is required"),
	phone: Yup.string().required("This field is required"),
	email: Yup.string(),
	address: Yup.string().required("This field is required"),
	// bvn: Yup.string(),
	business_name: Yup.string().required("This field is required"),
});

const EditCustomerModal = ({ customer }) => {
	const { user } = useAuth();
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const initialValues = {
		uuid: customer.uuid || "",
		first_name: customer.first_name || "",
		last_name: customer.last_name || "",
		phone: customer.phone || "",
		email: customer.email || "",
		address: customer.address || "",
		business_name: customer.business_name || "",
		// bvn: customer.bvn || "",
	};

	const { mutate, isLoading } = useMutation(updateCustomer, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["customers", customer?.uuid]);
			closePortal();
		},
	});

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit, errors }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-4">
					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="First Name"
						name="first_name"
						type="text"
						placeholder="First Name"
						error={errors.first_name}
						value={values.first_name}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Last Name"
						name="last_name"
						type="text"
						placeholder="Last Name"
						error={errors.last_name}
						value={values.last_name}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Phone"
						name="phone"
						type="text"
						placeholder="Phone"
						error={errors.phone}
						value={values.phone}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Email"
						name="email"
						type="text"
						placeholder="Email"
						error={errors.email}
						value={values.email}
						onChange={handleChange}
					/>

					{/* <FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="BVN"
						name="bvn"
						type="text"
						placeholder="BVN"
						error={errors.bvn}
						value={values.bvn}
						onChange={handleChange}
					/> */}

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Business Name"
						name="business_name"
						type="text"
						placeholder="Business Name"
						error={errors.business_name}
						value={values.business_name}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Address"
						name="address"
						type="text"
						placeholder="Address"
						error={errors.address}
						value={values.address}
						onChange={handleChange}
					/>

					<Button type="submit" variant="secondary" disabled={isLoading}>
						{isLoading ? "Updating..." : cn("Update ", getCustomizationValue(user, "customer_label", true))}
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default EditCustomerModal;
